/** Documento do fornecedor com pontuacao conforme o tamanho: CPF "000.000.000-00" (ate 11 digitos), CNPJ "00.000.000/0000-00". So digitos entram. */
export function mascaraDocumento(valor: string): string {
  const d = valor.replace(/\D/g, '').slice(0, 14);
  if (d.length <= 11) {
    const p = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9), d.slice(9, 11)];
    return [p[0], p[1] ? `.${p[1]}` : '', p[2] ? `.${p[2]}` : '', p[3] ? `-${p[3]}` : ''].join('');
  }
  const p = [d.slice(0, 2), d.slice(2, 5), d.slice(5, 8), d.slice(8, 12), d.slice(12, 14)];
  return [p[0], p[1] ? `.${p[1]}` : '', p[2] ? `.${p[2]}` : '', p[3] ? `/${p[3]}` : '', p[4] ? `-${p[4]}` : ''].join('');
}
